import {RuleConfig} from '@/plugins/api'
import {get} from 'lodash'

export default {
  namespaced: true,
  state: {
    submitDocumentConfig: {}
    //
  },
  actions: {
    async fetchSubmitDocumentConfig({commit}) {
      const res = await RuleConfig.fetch({type: 'submit-document-config'})
      commit('changeState', {submitDocumentConfig: get(res, '0', {})})
    },
    updateSubmitDocumentConfig(_, data) {
      return RuleConfig.create(data)
    }
  },
  getters: {
    submitDocumentConfig: state => state.submitDocumentConfig,
  }
}
